import { ThreeDotsMenu } from "@knowfully/ui.common";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  SxProps,
  Theme,
  useTheme,
} from "@mui/material";
import { useIntl } from "react-intl";
import { OrganizationCompletion } from "services/organizationPortalClient";

const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  icon: {
    color: theme.palette.primary.dark,
    height: "1.25rem",
    width: "1.25rem",
  },
  threeDots: {
    color: theme.palette.primary.dark,
  },
  menu: {
    color: theme.palette.primary.dark,
    ".MuiMenu-list": {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
});

export type ExamResultsDialogRequest = {
  completionId: string;
  courseTitle?: string;
};

type CertificatesThreeDotsMenuProps = {
  completion: OrganizationCompletion;
  onExamResults: (request: ExamResultsDialogRequest) => void;
  onDownloadAll: (completionId: string) => void;
};

const CertificatesThreeDotsMenu = ({
  completion,
  onExamResults,
  onDownloadAll,
}: CertificatesThreeDotsMenuProps) => {
  const styles = getStyles(useTheme());
  const { formatMessage: t } = useIntl();

  return (
    <ThreeDotsMenu
      sxThreeDots={styles.threeDots}
      sxMenu={styles.menu}
      ariaLabel={t({ id: "moreCertificateActions" })}
    >
      <MenuItem
        onClick={() =>
          onExamResults({
            completionId: completion.id,
            courseTitle: completion.courseTitle,
          })
        }
      >
        <ListItemIcon>
          <AssignmentTurnedInOutlinedIcon sx={styles.icon} />
        </ListItemIcon>
        <ListItemText primary={t({ id: "examResults" })} />
      </MenuItem>
      <MenuItem onClick={() => onDownloadAll(completion.id)}>
        <ListItemIcon>
          <FileDownloadOutlinedIcon sx={styles.icon} />
        </ListItemIcon>
        <ListItemText primary={t({ id: "viewCertificates" })} />
      </MenuItem>
    </ThreeDotsMenu>
  );
};

export default CertificatesThreeDotsMenu;
